import{useTheme as e}from"@mui/material/styles";import t from"@mui/material/useMediaQuery";const m=()=>{const m=e(),r=t(m.breakpoints.between("xs","sm")),s=t(m.breakpoints.between("sm","md"));return r?"mobile":s?"tablet":"desktop"};export{m as default};
//# sourceMappingURL=useScreenSize.js.map
